import { render, staticRenderFns } from "./moneyDetail.vue?vue&type=template&id=54d434be&"
import script from "./moneyDetail.vue?vue&type=script&lang=js&"
export * from "./moneyDetail.vue?vue&type=script&lang=js&"
import style0 from "./moneyDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports